import { FC } from "react";
import { Box, VBox } from "@/components-v2/Box";
import { observer } from "mobx-react";
import {
  EmploymentOfManagingDirectorForm,
  NAMED_PERSON,
} from "./employmentOfManagingDirectorDomain";
import { TextQuestion, YesNoQuestion } from "@/dbot/common/commonComponents";
import { TextArea } from "@/components-v2/TextArea";

import { useTranslation } from "@/stores/RootStoreContext";
import { RadioFieldQuestion } from "@/common/commonComponents";

export const EmploymentOfManagingDirectorView: FC<{
  form: EmploymentOfManagingDirectorForm;
}> = observer(({ form }) => {
  const { t } = useTranslation();

  return (
    <VBox gap={"md"}>
      <div className={"content"}>
        <Box paddingTop={false}>{t("kindly_note")}</Box>
        <Box paddingLeft={"md"} paddingTop={false}>
          <ul>
            <li>{t("decisionType.employmentOfManagingDirector.text.li1")}</li>
          </ul>
        </Box>
      </div>
      <TextQuestion
        question={t("decisions.employmentOfManagingDirector.newManagingDirector-helperText")}
        field={form.newManagingDirector}
        isLocked={form.isProjectLocked}
      />
      {form.newManagingDirector.inputValue && (
        <YesNoQuestion
          question={t(
            "decisions.employmentOfManagingDirector.createEmploymentAgreement-questionText",
          )}
          field={form.createManagingDirectorEmploymentAgreement}
          isLocked={form.isProjectLocked}
        />
      )}
      {form.createManagingDirectorEmploymentAgreement.value === true && (
        <VBox>
          <RadioFieldQuestion
            question={{
              key: "decisions.employmentOfManagingDirector.receivedEmploymentAgreement-questionText",
            }}
            fieldName="receivedManagingDirectorEmploymentAgreement"
            field={form.receivedManagingDirectorEmploymentAgreement}
            isLocked={form.isProjectLocked}
          />
        </VBox>
      )}
      {form.showShowEmploymentAgreementChanges && (
        <>
          <YesNoQuestion
            question={t(
              "decisions.employmentOfManagingDirector.showEmploymentAgreementChanges-questionText",
            )}
            field={form.showManagingDirectorEmploymentAgreementChanges}
            isLocked={form.isProjectLocked}
          />
          {form.showManagingDirectorEmploymentAgreementChanges.value === true && (
            <TextArea
              name={"managingDirectorEmploymentAgreementChanges"}
              value={form.managingDirectorEmploymentAgreementChanges.inputValue}
              onChange={form.managingDirectorEmploymentAgreementChanges.setInputValue}
              onBlur={form.managingDirectorEmploymentAgreementChanges.commit}
              readOnly={form.isProjectLocked}
            />
          )}
        </>
      )}
      {form.createManagingDirectorEmploymentAgreement.value === true &&
        form.receivedManagingDirectorEmploymentAgreement.value === "false" && (
          <>
            <YesNoQuestion
              question={t(
                "decisions.employmentOfManagingDirector.procuraEmploymentAgreementNegotiation-questionText",
              )}
              field={form.procuraManagingDirectorEmploymentAgreementNegotiation}
              isLocked={form.context.isBatchProject || form.isProjectLocked}
              infoText={
                form.context.isBatchProject ? t("decisions.disabled-in-batch.info-text") : undefined
              }
            />
            {form.procuraManagingDirectorEmploymentAgreementNegotiation.value === true && (
              <>
                <VBox>
                  <RadioFieldQuestion
                    question={{ key: "decisions.employmentOfManagingDirector.giveProcuraRights" }}
                    fieldName="newProcuraManagingDirectorEmploymentAgreementNegotiation"
                    field={form.newProcuraManagingDirectorEmploymentAgreementNegotiation}
                    isLocked={form.isProjectLocked}
                  />
                  {form.newProcuraManagingDirectorEmploymentAgreementNegotiation.value ===
                    NAMED_PERSON && (
                    <VBox marginLeft={"md"}>
                      <TextQuestion
                        question={t("decisions.employmentOfManagingDirector.giveProcuraRights")}
                        field={
                          form.newProcuraManagingDirectorEmploymentAgreementNegotiationNamedPerson
                        }
                        isLocked={form.isProjectLocked}
                      />
                    </VBox>
                  )}
                </VBox>
                {form.newProcuraManagingDirectorEmploymentAgreementNegotiation.value && (
                  <YesNoQuestion
                    question={t(
                      "decisions.employmentOfManagingDirector.giveProcuraEmploymentAgreementSigningSame-questionText",
                    )}
                    field={form.giveProcuraManagingDirectorEmploymentAgreementSigningSame}
                    isLocked={form.isProjectLocked}
                  />
                )}
              </>
            )}
          </>
        )}
      {form.createManagingDirectorEmploymentAgreement.value === true &&
        (form.receivedManagingDirectorEmploymentAgreement.value === "true" ||
          form.receivedManagingDirectorEmploymentAgreement.value === "changed") && (
          <YesNoQuestion
            question={t(
              "decisions.employmentOfManagingDirector.giveProcuraEmploymentAgreementSigning-questionText",
            )}
            field={form.giveProcuraManagingDirectorEmploymentAgreementSigning}
            isLocked={form.context.isBatchProject || form.isProjectLocked}
            infoText={
              form.context.isBatchProject ? t("decisions.disabled-in-batch.info-text") : undefined
            }
          />
        )}
      {form.showGiveProcuraRights && (
        <VBox>
          <RadioFieldQuestion
            question={{ key: "decisions.employmentOfManagingDirector.giveProcuraRights" }}
            fieldName="newProcuraManagingDirectorEmploymentAgreementSigning"
            field={form.newProcuraManagingDirectorEmploymentAgreementSigning}
            isLocked={form.isProjectLocked}
          />
          {form.newProcuraManagingDirectorEmploymentAgreementSigning.value === NAMED_PERSON && (
            <VBox marginLeft={"md"}>
              <TextQuestion
                question={t("decisions.employmentOfManagingDirector.giveProcuraRights")}
                field={form.newProcuraManagingDirectorEmploymentAgreementSigningNamedPerson}
                isLocked={form.isProjectLocked}
              />
            </VBox>
          )}
        </VBox>
      )}
    </VBox>
  );
});
